import styles from '../ComplaintTitle/ComplaintTitle.module.scss';
import betaIcon from '@image/beta-icon.svg';

interface SelectDropdownRowProps {
  option: { label: string };
  showBetaIcon: boolean;
}

const SelectDropdownRow = ({ option, showBetaIcon = true }: SelectDropdownRowProps) => {
  const codeInfo = option?.label?.split(' - ');
  if (codeInfo?.length > 0) {
    const displayName = codeInfo[0];
    const code = codeInfo[1];
    return (
      <span className={styles.dropdown__element__container}>
        {showBetaIcon && (
          <img
            className={styles.dropdown__beta__icon}
            alt={'beta-icon'}
            src={betaIcon}
          />
        )}
        <span>
          {displayName} <span className={styles.dropdown__item__code}>{code ? `${code}` : ''}</span>
        </span>
      </span>
    );
  }

  return '';
};

export default SelectDropdownRow;
